<template>
  <v-container>
    <v-toolbar color="light-gray" dense tabs>
      <v-tabs v-model="currentItem" color="transparent" fixed-tabs slider-color="green">
        <v-tab v-for="item in items2" :href="'#tab-' + item" :key="item">{{
          item
        }}</v-tab>
      </v-tabs>
    </v-toolbar>

    <v-tabs-items v-model="currentItem">
      <v-tab-item value="tab-Biometry">
        <v-flex lg12 md12 sm12 xs12 align-center>
          <v-card v-if="canViewResume">
            <v-card-text v-if="biometryDetection">
              <p class="font-weight-bold">Reconocimiento biométrico de la cara</p>
              <v-layout row wrap align-center justify-center>
                <v-flex lg6 md6 sm12 xs12 style="text-align: center;">
                    <img :src="faceImg" v-if="faceImg" height="250" />
                    <span class="material-icons" v-else>photo_size_select_actual</span>
                </v-flex>
                <v-flex lg6 md6 sm12 xs12 style="text-align: center;">
                  <v-progress-circular
                    :size="120"
                    :width="15"
                    :rotate="-90"
                    :value="biometryFront.confidence"
                    :color="color"
                  >
                    {{ biometryFront.confidence }}
                  </v-progress-circular>
                </v-flex>
              </v-layout>
              <v-layout row wrap align-center>
                <v-flex lg5 md5 sm5 xs5 align-center>
                  <div v-if="biometryFace">
                    <v-text-field
                      type="text"
                      v-model="biometryFace.gender"
                      label="Género"
                      readonly
                      outline
                    ></v-text-field>
                    <v-text-field
                      type="text"
                      v-model="biometryFace.age"
                      label="Edad"
                      readonly
                      outline
                    ></v-text-field>
                    <v-text-field
                      type="text"
                      v-model="biometryFace.glasses"
                      label="Gafas"
                      readonly
                      outline
                    ></v-text-field>
                    <v-text-field
                      type="text"
                      v-model="biometryFace.hairColor"
                      label="Color de pelo"
                      readonly
                      outline
                    ></v-text-field>
                  </div>
                </v-flex>
                <v-flex lg2 md2 sm2 xs2 align-center></v-flex>
                <v-flex lg5 md5 sm5 xs5 align-center>
                  <div v-if="biometryFace">
                    <v-text-field
                      type="text"
                      v-model="biometryFace.sideburns"
                      label="Patillas"
                      readonly
                      outline
                    ></v-text-field>
                    <v-text-field
                      type="text"
                      v-model="biometryFace.beard"
                      label="Barba"
                      readonly
                      outline
                    ></v-text-field>
                    <v-text-field
                      type="text"
                      v-model="biometryFace.moustache"
                      label="Bigote"
                      readonly
                      outline
                    ></v-text-field>
                  </div>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-text v-if="biometryDetection">
              <p class="font-weight-bold">Reconocimiento biométrico de la cara del documento</p>
              <v-layout row wrap align-center justify-center>
                <v-flex lg6 md6 sm12 xs12 style="text-align: center;">
                  <img :src="frontImg" v-if="frontImg" height="250" />
                  <span class="material-icons" v-else >photo_size_select_actual</span>
                </v-flex>
                <v-flex lg6 md6 sm12 xs12 style="text-align: center;">
                  <v-progress-circular
                    :size="120"
                    :width="15"
                    :rotate="-90"
                    :value="biometryFront.confidence"
                    :color="color"
                  >
                    {{ biometryFront.confidence }}
                  </v-progress-circular>
                </v-flex>
              </v-layout>
              <v-layout row wrap align-center>
                <v-flex lg5 md5 sm5 xs5 align-center>
                  <div v-if="biometryFront">
                    <v-text-field
                      type="text"
                      v-model="biometryFront.gender"
                      label="Género"
                      readonly
                      outline
                    ></v-text-field>
                    <v-text-field
                      type="text"
                      v-model="biometryFront.age"
                      label="Edad"
                      readonly
                      outline
                    ></v-text-field>
                    <v-text-field
                      type="text"
                      v-model="biometryFront.glasses"
                      label="Gafas"
                      readonly
                      outline
                    ></v-text-field>
                    <v-text-field
                      type="text"
                      v-model="biometryFront.hairColor"
                      label="Color de pelo"
                      readonly
                      outline
                    ></v-text-field>
                  </div>
                </v-flex>
                <v-flex lg2 md2 sm2 xs2 align-center></v-flex>
                <v-flex lg5 md5 sm5 xs5 align-center>
                  <div v-if="biometryFront">
                    <v-text-field
                      type="text"
                      v-model="biometryFront.sideburns"
                      label="Patillas"
                      readonly
                      outline
                    ></v-text-field>
                    <v-text-field
                      type="text"
                      v-model="biometryFront.beard"
                      label="Barba"
                      readonly
                      outline
                    ></v-text-field>
                    <v-text-field
                      type="text"
                      v-model="biometryFront.moustache"
                      label="Bigote"
                      readonly
                      outline
                    ></v-text-field>
                  </div>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex> 
      </v-tab-item>
      <v-tab-item value="tab-Front">
        <v-flex lg12 md12 sm12 xs12 align-center>
          <v-card v-if="frontDetection">
            <v-card-text>
              <p class="font-weight-bold">Reconocimiento del frontal del documento</p>
              <v-layout row wrap align-center justify-center>
                <v-flex lg6 md6 sm12 xs12 style="text-align: center;">
                  <img :src="frontImg" v-if="frontImg" height="250" />
                  <span class="material-icons" v-else >photo_size_select_actual</span>
                </v-flex>
                <v-flex lg6 md6 sm12 xs12 style="text-align: center;">
                  <v-progress-circular
                    :size="120"
                    :width="15"
                    :rotate="-90"
                    :value="biometryFront.frontConfidence"
                    :color="color"
                  >
                    {{ biometryFront.frontConfidence }}
                  </v-progress-circular>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex lg12 md12 sm12 xs12 align-center>
          <v-card v-if="hologramDetection">
            <v-card-text>
              <p class="font-weight-bold">Reconocimiento del holograma del documento</p>
              <v-layout row wrap align-center justify-center>
                <v-flex lg6 md6 sm12 xs12 style="text-align: center;">
                  <img :src="hologramImg" v-if="hologramImg" height="250" />
                  <span class="material-icons" v-else>photo_size_select_actual</span>
                </v-flex>
                <v-flex lg6 md6 sm12 xs12 style="text-align: center;">
                  <v-progress-circular
                    :size="120"
                    :width="15"
                    :rotate="-90"
                    :value="hologramConfidence"
                    :color="color"
                  >
                    {{ hologramConfidence }}
                  </v-progress-circular>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-tab-item>
      <v-tab-item value="tab-Back">
        <v-flex lg12 md12 sm12 xs12 align-center>
          <v-card v-if="backDetection">
            <v-card-text v-if="ocr">
              <p class="font-weight-bold">Reconocimiento del reverso del documento</p>
              <v-layout row wrap align-center justify-center>
                <v-flex lg6 md6 sm12 xs12 style="text-align: center;">
                  <img :src="backImg" v-if="backImg" height="250" />
                  <span class="material-icons" v-else>photo_size_select_actual</span>
                </v-flex>
                <v-flex lg6 md6 sm12 xs12 style="text-align: center;">
                  <v-progress-circular
                    :size="120"
                    :width="15"
                    :rotate="-90"
                    :value="ocr.backConfidence"
                    :color="color"
                  >
                    {{ ocr.backConfidence }}
                  </v-progress-circular>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-tab-item>
      <v-tab-item value="tab-Ocr">
        <v-flex lg12 md12 sm12 xs12 align-center>
          <v-card v-if="backDetection">
            <v-card-text>
              <p class="font-weight-bold">Datos extraídos del documento</p>
              <v-layout row wrap align-center>
                <v-flex lg12 md12 sm12 xs12 align-center>
                  <v-layout row wrap align-center>
                    <v-flex lg5 md5 sm5 xs12 align-center>
                      <div v-if="ocr">
                        <v-text-field
                          type="text"
                          v-model="ocr.icarName"
                          label="Nombre"
                          readonly
                          outline
                        ></v-text-field>
                        <v-text-field
                          type="text"
                          v-model="ocr.icarLastName"
                          label="Apellidos"
                          readonly
                          outline
                        ></v-text-field>
                        <v-text-field
                          type="text"
                          v-model="ocr.icarNif"
                          label="Número del documento"
                          readonly
                          outline
                        ></v-text-field>
                        <v-text-field
                          type="text"
                          v-model="ocr.icarExpirationDate"
                          label="Fecha de expiración"
                          readonly
                          outline
                        ></v-text-field>
                        <v-text-field
                          type="text"
                          v-model="ocr.icarDocType"
                          label="Tipo de documento"
                          readonly
                          outline
                        ></v-text-field>
                      </div>
                    </v-flex>
                    <v-flex lg2 md2 sm2 xs2 align-center> </v-flex>
                    <v-flex lg5 md5 sm12 xs12 align-center>
                      <div v-if="ocr">
                        <v-text-field
                          type="text"
                          v-model="ocr.icarBirthDate"
                          label="Fecha de nacimiento"
                          readonly
                          outline
                        ></v-text-field>
                        <v-text-field
                          type="text"
                          v-model="ocr.icarSex"
                          label="Género"
                          readonly
                          outline
                        ></v-text-field>
                        <v-text-field
                          type="text"
                          v-model="ocr.icarAddress"
                          label="Dirección"
                          readonly
                          outline
                        ></v-text-field>
                        <v-text-field
                          type="text"
                          v-model="ocr.icarNationality"
                          label="Nacionalidad"
                          readonly
                          outline
                        ></v-text-field>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex lg12 md12 sm12 xs12 align-center>
          <v-card v-if="backDetection">
            <v-card-text>
              <p class="font-weight-bold">Datos del cliente</p>
              <v-layout row wrap align-center>
                <v-flex lg12 md12 sm12 xs12 align-center>
                  <v-layout row wrap align-center>
                    <v-flex lg5 md6 sm12 xs12 align-center>
                      <div v-if="customer">
                        <v-text-field
                          type="text"
                          v-model="customer.name"
                          label="Nombre"
                          readonly
                          outline
                        ></v-text-field>
                        <v-text-field
                          type="text"
                          v-model="customer.lastname"
                          label="Apellidos"
                          readonly
                          outline
                        ></v-text-field>
                      </div>
                    </v-flex>
                    <v-flex lg2 md2 sm2 xs2 align-center> </v-flex>
                    <v-flex lg5 md6 sm12 xs12 align-center>
                      <div v-if="customer">
                        <v-text-field
                          type="text"
                          v-model="customer.nif"
                          label="Número del documento"
                          readonly
                          outline
                        ></v-text-field>
                        <v-text-field
                          type="text"
                          v-model="customer.email"
                          label="Correo eletrónico"
                          readonly
                          outline
                        ></v-text-field>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-tab-item>
    </v-tabs-items>
    <p class="esign-error-text" v-if="tokenMsg">
      El token es un campo obligatorio para poder firmar la operación.
    </p>
    <p class="esign-error-text" v-if="endPointMsg">
      El end point es un campo obligatorio para poder firmar la operación.
    </p>
    <p class="esign-error-text" v-if="videoUuidMsg">
      El identificador del vídeo es un campo obligatorio para poder firmar la
      operación.
    </p>
    <p class="esign-error-text" v-if="operationUuidMsg">
      El identificador de la operación es un campo obligatorio para poder firmar
      la operación.
    </p>
    <p id="snackbar-success"></p>
    <p id="snackbar-error"></p>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  name: "Videoresume",
  props: {
    // currentItem: "tab-Web",
    // items2: ["Video", "Biometry", "Front", "Back", "Ocr"],
    token: { type: String, required: true },
    endPoint: { type: String, required: true },
    videoUuid: { type: String, required: true },
    operationUuid: { type: String, required: true },
    isPassport: { type: Boolean, default: false },
    faceDetection: { type: Boolean, default: true },
    frontDetection: { type: Boolean, default: true },
    biometryDetection: { type: Boolean, default: true },
    hologramDetection: { type: Boolean, default: true },
    backDetection: { type: Boolean, default: true },
    loading: { type: Boolean, default: false },
    snackBar: { type: Boolean, default: false },
    status: { type: Number, default: 0 },
    response: { type: String, default: "" },
    successMsg: {
      type: String,
      default:
        "Se han cosenguido los datos para el resumen de la identificación"
    },
    errorMsg: {
      type: String,
      default: "Ha ocurrido un error al obtener el resumen de la identificación"
    }
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player;
    },
    color() {
      if (this.biometryFront.confidence < 40) return "#FF0000";
      else if (this.biometryFront.confidence < 50) return "#FF6600";
      else return "#00FF00";
    }
  },
  created() {
    this.tokenMsg =
      (typeof this.token === "undefined" || this.token === "") === true;
    this.endPointMsg =
      (typeof this.endPoint === "undefined" || this.endPoint === "") === true;
    this.operationUuidMsg =
      (typeof this.operationUuid === "undefined" ||
        this.operationUuid === "") === true;
    this.videoUuidMsg =
      (typeof this.videoUuid === "undefined" || this.videoUuid === "") === true;
    this.isPassportMsg =
      (typeof this.isPassport === "undefined" || this.isPassport === "") ===
      true;
    if (
      this.tokenMsg === true ||
      this.endPoint === true ||
      this.operationUuidMsg ||
      this.videoUuidMsg
    ) {
      this.canViewResume = false;
    } else {
      this.getVideoResults();
    }
  },
  watch: {
    videoUuid() {
      this.canViewResume = true;
      this.videoUuidMsg = false;
      this.getVideoResults();
    }
  },
  data() {
    return {
      tokenMsg: false,
      endPointMsg: false,
      videoUuidMsg: false,
      operationUuidMsg: false,
      canViewResume: true,
      faceImg: undefined,
      frontImg: undefined,
      biometryFace: undefined,
      biometryFront: undefined,
      hologramImg: undefined,
      hologramConfidence: undefined,
      backImg: undefined,
      ocr: undefined,
      customer: undefined,
      currentItem: "tab-Biometry",
      items2: ["Biometry", "Front", "Back", "Ocr"] // "Video",
      // https://github.com/surmon-china/vue-video-player
      // playerOptions: {
      //   // videojs options
      //   width: 640,
      //   height: 480,
      //   autoplay: false,
      //   muted: true,
      //   language: "es",
      //   playbackRates: [0.7, 1.0, 1.5, 2.0],
      //   sources: [
      //     {
      //       type: "video/webm",
      //       src: `${this.endPoint}${"identification/video/"}${this.operationUuid}${"/"}${this.videoUuid}`
      //     }
      //   ],
      //   poster: "/static/images/author.jpg"
      // }
    };
  },
  methods: {
    getVideoResults() {
      if (this.loading) {
        this.showLoading();
      }
      debugger;
      this.EventBus.$emit("notify", "showLoading");
      axios
        .get(
          `${this.endPoint}${"identification/images/data/"}${
            this.operationUuid
          }${"/"}${this.videoUuid}`,
          { headers: { "Content-type": "Application/json" } }
        )
        .then(
          responseSuccess => {
            debugger;
            if (this.loading) {
              this.hideLoading();
            }
            if (this.isPassport) {
              this.frontImg = responseSuccess.data.passport;
              this.customer = responseSuccess.data.customer;
              this.backImg = responseSuccess.data.passportmrz;
              this.ocr = responseSuccess.data.passportOcr;
              if (this.biometryDetection) {
                this.biometryFront = this.getFaceBiometryDataFormated(
                  responseSuccess.data.faceBiometry.faceAttributes
                );
                this.biometryFront.frontConfidence =
                  (Math.round(
                    responseSuccess.data.frontBiometry.frontConfidence * 100
                  ) /
                    100) *
                  100;
                if (this.biometryFront.frontConfidence.toString().length > 5) {
                  this.biometryFront.frontConfidence = parseFloat(
                    this.biometryFront.frontConfidence
                      .toString()
                      .substring(0, 5)
                  );
                }
              }
            } else {
              if (this.backDetection) {
                this.backImg = responseSuccess.data.back;
                this.customer = responseSuccess.data.customer;
                this.ocr = responseSuccess.data.backOcr;
                if (responseSuccess.data.backOcr.icarSex !== "undefined") {
                  if (responseSuccess.data.backOcr.icarSex === "M") {
                    this.ocr.icarSex = "Male";
                  } else {
                    this.ocr.icarSex = "Female";
                  }
                }
                this.ocr.backConfidence =
                  (Math.round(
                    responseSuccess.data.backOcr.backConfidence * 100
                  ) /
                    100) *
                  100;
                if (this.ocr.backConfidence.toString().length > 5) {
                  this.ocr.backConfidence = parseFloat(
                    this.ocr.backConfidence.toString().substring(0, 5)
                  );
                }
              }
              if (this.hologramDetection) {
                this.hologramImg = responseSuccess.data.hologram;
                this.hologramConfidence =
                  (Math.round(responseSuccess.data.hologramConfidence * 100) /
                    100) *
                  100;
                if (this.hologramConfidence.toString().length > 5) {
                  this.hologramConfidence = parseFloat(
                    this.hologramConfidence.toString().substring(0, 5)
                  );
                }
              }
              if (this.frontDetection) {
                this.frontImg = responseSuccess.data.front;
              }
              if (this.biometryDetection) {
                this.biometryFace = this.getFaceBiometryDataFormated(
                  responseSuccess.data.faceBiometry.faceAttributes
                );
                this.biometryFront = this.getFaceBiometryDataFormated(
                  responseSuccess.data.frontBiometry.frontAttributes
                );
                this.biometryFront.confidence =
                  (Math.round(
                    responseSuccess.data.frontBiometry.confidence * 100
                  ) /
                    100) *
                  100;
                this.biometryFront.frontConfidence =
                  (Math.round(
                    responseSuccess.data.frontBiometry.frontConfidence * 100
                  ) /
                    100) *
                  100;
                if (this.biometryFront.confidence.toString().length > 5) {
                  this.biometryFront.confidence = parseFloat(
                    this.biometryFront.confidence.toString().substring(0, 5)
                  );
                }
                if (this.biometryFront.frontConfidence.toString().length > 5) {
                  this.biometryFront.frontConfidence = parseFloat(
                    this.biometryFront.frontConfidence
                      .toString()
                      .substring(0, 5)
                  );
                }
              }
            }
            if (this.faceDetection) {
              this.faceImg = responseSuccess.data.face;
            }
            if (this.snackBar) {
              this.$showSnackBar("snackbar-success", this.successMsg);
            }
            this.EventBus.$emit("notify", "hideLoading");
            this.EventBus.$emit("success");
          },
          responseError => {
            if (this.loading) {
              this.hideLoading();
            }
            if (this.snackBar) {
              this.$showSnackBar("snackbar-error", this.errorMsg);
            }
            this.EventBus.$emit("notify", "hideLoading");
            this.EventBus.$emit("error");
          }
        );
    },
    getFaceBiometryDataFormated(biometryFace) {
      let biometry = {};
      if (biometryFace.gender === "male") {
        biometry.gender = "Masculino";
      } else {
        biometry.gender = "Femenino";
      }
      biometry.age = biometryFace.age;
      if (biometryFace.facialHair.sideburns > 0.4) {
        biometry.sideburns = "Si";
      } else {
        biometry.sideburns = "No";
      }
      if (biometryFace.facialHair.beard > 0.4) {
        biometry.beard = "Si";
      } else {
        biometry.beard = "No";
      }
      if (biometryFace.facialHair.moustache > 0.4) {
        biometry.moustache = "Si";
      } else {
        biometry.moustache = "No";
      }
      if (biometryFace.glasses === "NoGlasses") {
        biometry.glasses = "Sin gafas";
      } else if (biometryFace.glasses === "ReadingGlasses") {
        biometry.glasses = "Gafas de leer";
      } else if (biometryFace.glasses === "SunGlasses") {
        biometry.glasses = "Gafas de sol";
      } else {
        biometry.glasses = "";
      }
      biometry.hairColor = Math.max(
        ...biometryFace.hair.hairColor.map(hair => hair.confidence),
        0
      );
      biometryFace.hair.hairColor.forEach((value, index) => {
        if (value.confidence === biometry.hairColor) {
          biometry.hairColor = value.color;
        }
      });
      if (biometry.hairColor === "black") {
        biometry.hairColor = "Negro";
      } else if (biometry.hairColor === "brown") {
        biometry.hairColor = "Marrón";
      } else if (biometry.hairColor === "gray") {
        biometry.hairColor = "Gris";
      } else if (biometry.hairColor === "other") {
        biometry.hairColor = "Otro";
      } else if (biometry.hairColor === "blond") {
        biometry.hairColor = "Rubio";
      } else if (biometry.hairColor === "red") {
        biometry.hairColor = "Pelirrojo";
      } else {
        biometry.hairColor = "";
      }
      return biometry;
    },
  }
};
</script>

<style scoped>
.verificationImages {
  width: 100%;
  height: 250px;
}
.faceImage {
  width: 25%;
  float: left;
}
.frontImage {
  width: 25%;
  float: left;
}
.hologramImage {
  width: 25%;
  float: left;
}
.backImage {
  width: 25%;
  float: left;
}
.biometryForm {
  width: 100%;
  height: 330px;
}
.biometryFaceImage {
  width: 25%;
  /* display: block; */
  float: left;
}
.biometryFaceData {
  width: 8%;
  padding-right: 5%;
  /* display: inline-block; */
  float: left;
}
.biometryFrontImage {
  width: 38%;
  /* padding-right: 5%; */
  /* display: block; */
  float: left;
}
.biometryFrontData {
  width: 8%;
  padding-right: 3%;
  /* display: inline-block; */
  float: left;
}
.hologramForm {
  width: 100%;
  height: 250px;
}
.hologramDetectionImage {
  width: 20%;
  /* display: block; */
  float: left;
}
.hologramData {
  width: 8%;
  /* display: inline-block; */
  float: left;
}
.ocrForm {
  width: 100%;
  height: 300px;
}
.customerData {
  width: 8%;
  float: left;
  margin-right: 5%;
}
.backOcrData {
  width: 8%;
  float: left;
  margin-right: 5%;
  margin-left: 5%;
}
.esign-label-text-title {
  font-size: 12pt;
  font-weight: bold;
  margin-bottom: 20px;
}
.marBot10 {
  margin-bottom: 5px;
}
.pad20 {
  padding: 20px;
}
.padTop20 {
  padding-top: 20px;
}
.w100 {
  width: 200%;
}
@media only screen and (min-width: 1264px) {
  .container {
    max-width: 1800px;
  }
}
</style>
